import { useRootStore } from './useRootStore'

export function useLoadingMode() {
  const { rootStore } = useRootStore()

  return rootStore.loadingMode
}
